import React, { useState, useEffect } from 'react';
import { projectsData as fallbackData } from '../mock';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/projects`);
        if (!response.ok) {
          throw new Error('Error fetching projects');
        }
        const data = await response.json();
        setProjects(data);
      } catch (err) {
        console.error('Error loading projects:', err);
        // Use fallback data if API fails
        setProjects(fallbackData);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <section id="proyectos" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">Proyectos</h2>
          <div className="w-24 h-1 bg-[#5E8B7E] mx-auto mb-6"></div>
          <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
            Soluciones técnicas aplicadas en proyectos de diversa escala y complejidad
          </p>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="flex justify-center py-12" data-testid="projects-loading">
            <Loader2 className="animate-spin text-[#5E8B7E]" size={40} />
          </div>
        )}

        {/* Projects Grid */}
        {!loading && (
          <div className="grid md:grid-cols-2 gap-8" data-testid="projects-list">
            {projects.map((project, index) => (
              <Card
                key={project._id || index}
                className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
                data-testid={`project-card-${index}`}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A3A48]/80 to-transparent"></div>
                  <Badge className="absolute top-4 right-4 bg-[#5E8B7E] text-white">
                    {project.category}
                  </Badge>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-[#0A3A48] mb-3 group-hover:text-[#5E8B7E] transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-[#4A4A4A] leading-relaxed">
                    {project.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;
